<ras-page>
	<main>
		<h1>Packing &amp; moving tips</h1>

		<p class="lead">For your convenience, some useful tips to help you when moving or storing your goods.</p>

		<nav>
			<ul>
				<li><a routerLink="./" fragment="planning-and-organising-storage">Planning and organising your storage</a></li>
				<li><a routerLink="./" fragment="packing-and-storing-boxes">Packing and storing your boxes</a></li>
				<li><a routerLink="./" fragment="storing-clothing-and-curtains">Storing clothing and curtains</a></li>
				<li><a routerLink="./" fragment="furniture-storage">Furniture storage</a></li>
				<li><a routerLink="./" fragment="packing-breakables">Packing breakables</a></li>
				<li><a routerLink="./" fragment="appliances-and-equipment">Appliances and equipment</a></li>
				<li><a routerLink="./" fragment="archiving-documents">Archiving documents</a></li>
				<li><a routerLink="./" fragment="prohibited-items">Prohibited items</a></li>
			</ul>
		</nav>

		<h3 id="planning-and-organising-storage">Planning and organising your storage</h3>

		<ul>
			<li>Plan it. Place items in front that will be accessed frequently and allow for walkways so that you can get to items stored at the back of your storage space.</li>
			<li>Map it. As you move into your storage space, make a simple drawing that records where items are placed.</li>
			<li>Keep a written inventory as you pack. Calculate the value of the goods you are storing and arrange insurance.</li>
			<li>Do not lean items against the walls. Pack your items at least 150mm from walls to allow air to flow between the structure and your goods preventing possible moisture build up.</li>
			<li>If you frequently use your storage space, a larger space will give you more room to move than one packed to capacity.</li>
			<li>Be Prepared. Gather all the packing materials you need before you start. Our Packing Supplies page provides a comprehensive list of what you may need.</li>
		</ul>


		<h3 id="packing-and-storing-boxes">Packing and storing your boxes</h3>

		<ul>
			<li>Use good quality storage boxes.</li>
			<li>Tape it up. Make sure all your packed boxes are securely sealed with packing tape, with tops folded flat and not bulging.</li>
			<li>Try to use boxes in uniform sizes where possible. They are much easier to stack.</li>
			<li>Use the right boxes. Use large boxes for light items and smaller boxes for heavier items.</li>
			<li>Pack your heaviest items at the bottom and lighter items on top.</li>
			<li>Do not overload boxes. Boxes should only weigh as much as the average person can lift without straining.</li>
			<li>Label boxes with a list of contents packed for easy identification.</li>
			<li>Pack books in sealed plastic and lay them flat to protect their spines.</li>
		</ul>


		<h3 id="storing-clothing-and-curtains">Storing clothing and curtains</h3>

		<ul>
			<li>Clothing and curtains should not be stored on hangers.</li>
			<li>Never pack bedding or clothes in plastic bags, unless they are vacuum sealed, as they will sweat and spoil. To save space and to protect your pillows and linen, seal them in vacuum sealed bags.</li>
			<li>Use moth balls in boxes where clothing or linen is stored.</li>
		</ul>


		<h3 id="furniture-storage">Furniture storage</h3>

		<ul>
			<li>Break it down. Disassemble bed frames and wrap them together with tape or rope. Use small plastic bags to store screws and bolts and tape them to the frame that they belong to.</li>
			<li>Wrap furniture edges and chair legs with corner protectors or bubble wrap to protect them from getting damaged.</li>
			<li>Protect your soft furnishings with covers.</li>
			<li>Vacuum and clean furniture thoroughly before storing to avoid permanent staining.</li>
			<li>Furniture with drawers and cupboards can be used as storage places for china, silverware and small items. Wrap breakable items in bubble wrap.</li>
			<li>Stack chairs seat to seat with cloth or print free paper separating them.</li>
		</ul>

		<h3 id="packing-breakables">Packing breakables</h3>

		<ul>
			<li>All glass items should be individually wrapped with print free paper wraps and packed near the top of boxes. Empty pockets in the boxes should be filled with print free paper wraps to cushion the items.</li>
			<li>Plates and saucers should never be packed flat. Once covered with protective wrapping, pack them vertically, on their side edges.</li>
			<li>Wrap pictures and mirrors individually, with corner protectors, in bubble wrap. Mark as fragile and stack them vertically on the frame or mirror edge, away from walls.</li>
		</ul>


		<h3 id="appliances-and-equipment">Appliances and equipment</h3>

		<ul>
			<li>A refrigerator, freezer or washing machine should be thoroughly dry and stored with its door slightly ajar. Such appliances make excellent packing places for blankets, towels, tablecloths and clothes.</li>
			<li>Make sure that stoves and cooking equipment are thoroughly cleaned before they are stored.</li>
			<li>Clean all outside garden tools and equipment before packing.</li>
			<li>Remove batteries from any equipment to avoid damage from leaking batteries.</li>
			<li>Drain fuel and oil from machinery. This reduces the risk of leakage, spillage or damage to other goods in your storage space. Petrol and oil are also a fire hazard and not permitted to be stored.</li>
			<li>Bicycles and other metal items may rust over time if not protected. To prevent rust, wipe all metal surfaces with an appropriate agent.</li>
		</ul>


		<h3 id="archiving-documents">Archiving documents</h3>

		<ul>
			<li>To preserve your documents, and to save space, documents should be removed from lever arch files and filed in document boxes.</li>
			<li>Where easy access is necessary, document boxes can be stored on shelving. Stand alone shelving may be used however no wall fixtures are permitted.</li>
			<li>Archive boxes are ideal and should be clearly marked and catalogued.</li>
		</ul>


		<h3 id="prohibited-items">Prohibited items</h3>

		<p>To ensure the safety of everyone’s belongings, and in adherence to regulations, the following list of items is prohibited from our storage facilities:</p>

		<ul>
			<li>Toxic waste and radioactive materials</li>
			<li>Explosives, firearms and ammunitions</li>
			<li>Fuel, gas and other flammable or hazardous products</li>
			<li>Living plants or animals</li>
			<li>Perishables including all food</li>
			<li>Cash and securities such as share certificates and title deeds</li>
			<li>Illegal goods or substances</li>
		</ul>
	</main>
</ras-page>